var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222628",
    fillRule: "evenodd",
    d: "M10.86 6.083c-3.044 0-5.419 1.739-7.484 4.282a.21.21 0 0 0 0 .269c2.065 2.543 4.44 4.282 7.485 4.282s5.419-1.739 7.484-4.282a.21.21 0 0 0 0-.27c-2.065-2.542-4.44-4.281-7.484-4.281M2.47 9.629c2.162-2.661 4.835-4.713 8.39-4.713s6.23 2.052 8.39 4.713a1.38 1.38 0 0 1 0 1.74c-2.16 2.662-4.834 4.714-8.39 4.714-3.555 0-6.228-2.052-8.39-4.714a1.38 1.38 0 0 1 0-1.74",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222628",
    fillRule: "evenodd",
    d: "M10.86 8.999a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.666 1.5a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.333 0",
    clipRule: "evenodd"
  })));
};
export default SvgEye;